import Vue from 'vue'
import Vuex from 'vuex'

import work from './modules/h5work'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shoppingCartNum: false, //购物车数量变化
    userInfo: {}, //用户信息
    allowPay: 1, //当前商城是否开启支付功能 1开启 0关闭
    openOrderServiceFee: 1, //当前商城是否开启服务模块 1开启 0关闭
  },
  mutations: {
    SET_SHOPCARTNUM: state => {
      state.shoppingCartNum = !state.shoppingCartNum
    },
    SET_USERINFO: (state, value) => {
      state.userInfo = value.userInfo
      state.allowPay = value.allowPay
      state.openOrderServiceFee = value.openOrderServiceFee
    },
  },
  // actions: {
  //   setUserType({
  //     commit
  //   }, value) {
  //     commit('aaa', value)
  //   },
  // },
  getters: {
    //用户类型A(平台1 商家2)
    userTypeA: (state) => {
      let res = false
      if (state.userInfo.userType == 1 || state.userInfo.userType == 2) {
        res = true
      }
      return res
    },
  },
  modules: {
    work
  },
})